//
import axios from 'axios'

/**
 * 
 */
const assign_parent = wh_item_parent_id => async wh_item_id => {
    //
    const route    = process.env.VUE_APP_API_ROUTE.concat( '/wh_item/' ).concat( wh_item_id ).concat( '/repacking_parents' )
        , response = await axios.post( route, { item_parents: [ wh_item_parent_id ] } )
    //
    return response
}

/**
 * 
 */
const delete_parent = wh_item_parent_id => async wh_item_id => {
    //
    const route    = process.env.VUE_APP_API_ROUTE.concat( '/wh_item/' ).concat( wh_item_id ).concat( '/repacking_parents' )
        , response = await axios.delete( route, { data: { item_parents: [ wh_item_parent_id ] } } )
    //
    return response
}

/**
 *
 */
export default async ( id, data ) => {
    //
    const promises = [
        ...data.item_parents.map( assign_parent( id ) ),
        ...data.item_origins.map( delete_parent( id ) ),
    ]
    //
    try {
        //
        const response = await Promise.all( promises ).then( values => { 
            console.log('then')
            return {
                status: 'success'
            }
        })
        //
        return response
    } catch ( error ) {
        //
        return error.response.data
    }
}
